import React from 'react';

interface PerforationDividerProps {
  className?: string;
  notch?: boolean;
  dense?: boolean;
  notchOffset?: number | string;
}

export const PerforationDivider: React.FC<PerforationDividerProps> = ({
  className = '',
  notch = true,
  dense = false,
  notchOffset = '2.5rem',
}) => {
  const pattern = dense
    ? 'bg-[repeating-linear-gradient(to_bottom,theme(colors.gray.300)_0_3px,transparent_3px_9px)]'
    : 'bg-[repeating-linear-gradient(to_bottom,theme(colors.gray.300)_0_6px,transparent_6px_12px)]';

  return (
    <div className={['pointer-events-none select-none', 'w-[2px] h-full relative z-0', pattern, className].join(' ')}>
      {notch && (
        <>
          <div
            className="absolute left-1/2 -translate-x-1/2 w-3.5 h-3.5 rounded-full border border-gray-300 bg-white"
            style={{top: typeof notchOffset === 'number' ? `${notchOffset}px` : notchOffset}}
          />
          <div
            className="absolute left-1/2 -translate-x-1/2 w-3.5 h-3.5 rounded-full border border-gray-300 bg-white"
            style={{bottom: typeof notchOffset === 'number' ? `${notchOffset}px` : notchOffset}}
          />
        </>
      )}
    </div>
  );
};
